module.exports = __webpack_public_path__ + "img/img_lt.ca048ea9.png";